
import keepIcon from '../../assets/book_icon2.png';
import bannerMobile from '../../assets/mobile/bkp/banner.png';
import dacu from '../../assets/dacu.png';
import bookOcr from '../../assets/book_ocr.png';
import bookShishi from '../../assets/book_shishi.png';
import bookZhineng from '../../assets/book_zhineng.png';
import bookShuiwu from '../../assets/book_shuiwu.png';
import bookShouci from '../../assets/book_shouci.png';
import bookRichang from '../../assets/book_richang.png';
import bookQiehu from '../../assets/book_qiehu.png';
import bookZhuanye from '../../assets/book_zhuanye.png';
import bookDijia from '../../assets/book_dijia.png';
import bookAnquan from '../../assets/book_anquan.png';
import bookShouhou from '../../assets/book_shouhou.png';

export const metaInfo = {
    title: '代理记账服务_代理做账报税服务_百度智能云企业服务中心',
    meta: [
        {
            name: 'keywords',
            content: '代理记账,代账公司,记账报税,财税代理,全国代理记账'
        },
        {
            name: 'description',
            content: '百度智能云企业服务代理记账服务，资深团队多对一服务，做账准确，线上随时查账，服务范围支持全国'
        }
    ]
};

export const baseInfo = {
    icon: keepIcon,
    title: '代理记账服务',
    des: '云会计代理记账，品质服务，安心代账',
    price: '0元',
    unit: '/年',
    priceIcon: dacu,
    originPrice: '0元/年',
    advantage: ['实时响应，专家服务', '一次性收费，无隐形费用', '服务流程全监管'],
    serviceAdvantage: ['经营性网站必备资质', '助企业合法合规经营', '新品上架，限时优惠'],
    activityContent: '截止8月31日下单，免费延长服务1个月。'
};

export const baseInfoModile = {
    icon: bannerMobile,
    title: '代理记账服务',
    drawerTitle: '代理记账选配',
    des: '云会计代理记账，品质服务，安心代账',
    price: '1199',
    unit: '元/年',
    priceIcon: dacu,
    originPrice: '1999元/年',
    isShowPriceIcon: true,
    isShowOriginPrice: true,
    tips: [
        {text: '实时响应，专家服务', className: 'fast-icon'},
        {text: '服务流程全监管', className: 'consult-icon'},
        {text: '一次性收费，无隐形费用', className: 'cbs-icon'}
    ]
};

export const serviceContent = [
    '建立账套',
    '整理原始凭证',
    '每月核对票据',
    '每月编制记账凭证',
    '编制资产负债表、利润表',
    '增值税、印花税、附加税、个人所得税、企业所得税等纳税申报',
    '每月装订记账凭证，总账、明细账、财税报表',
    '企业所得税年度汇算清缴申报',
    '工商年报（企业年检）'
];

export const advantage = [
    {
        icon: bookOcr,
        title: 'OCR票据识别',
        des: '运用OCR图像扫描技术，帮助会计快速识别票据并查验核实真伪，提高做账效率'
    },
    {
        icon: bookShishi,
        title: '实时查账',
        des: '在线查看企业账务情况，服务进度实时可查，一目了然'
    },
    {
        icon: bookZhineng,
        title: '智能生成凭证',
        des: '将发票或单据自动匹配会计科目，根据不同经济活动将票据分类，自动生成对应凭证'
    },
    {
        icon: bookShuiwu,
        title: '税务风险预警',
        des: '对帐数据发现风险第一时间预警，并提供相关财税建议'
    }
];

export const materials = [
    {
        title: '首次做账所需材料',
        des: ['营业执照', '税号及报税密码'],
        icon: bookShouci,
        className: 'materials-item1'
    },
    {
        title: '日常月度记账所需材料',
        des: ['发票清单', '银行对账单、回执单、工资单'],
        icon: bookRichang,
        className: 'materials-item2'
    },
    {
        title: '切户所需材料',
        des: ['交接单/历史账簿/凭证/纳税申报表', '税号及报税密码，税控盘（可选）'],
        icon: bookQiehu,
        className: 'materials-item3'
    }
];

export const problem = [
    {
        title: '什么是0申报？',
        des: '0申报需要符合 1、无银行、支付宝、微信流水（账户管理费除外） 2、无票据（收入票、费用票）3、无社保、员工工资 4、无纳税额 '
    },
    {
        title: '我获得的服务结果？',
        des: '财务报表、记账凭证、纳税申报表、账本'
    },
    {
        title: '都有什么票据可以用来做账？',
        des: '发票、银行单据、工资表、现金借款收支单据等'
    },
    {
        title: '我可以不请会计，自己做账吗？',
        des: '不行的，《会计法》规定从事会计工作的人员都必须取得会计从业资格证，必须是会计才能做账'
    },
    {
        title: '新注册的公司没业务，是否可以不记账不报税？',
        des:
            '不可以，工商、税务已经于2015年6月1日与中国人民银行个人引用征信系统联网，公司未注销的情况下，必须做账报税，否则法人及股东将会有信用污点'
    },
    {
        title: '每月几号开始记账，几号报税？',
        des: '每月票收到就开始记账，1-15日报税，法定节假日按照税局要求调整'
    }
];

export const intro = [
    {
        text: '专业咨询',
        icon: bookZhuanye
    },
    {
        text: '低价透明',
        icon: bookDijia
    },
    {
        text: '安全保密',
        icon: bookAnquan
    },
    {
        text: '售后无忧',
        icon: bookShouhou
    }
];

export const taxpayerTypeDataSource = [
    {
        label: '小规模纳税人',
        value: 'SMALL_SCALE_TAXPAYER'
    },
    {
        label: '一般纳税人',
        value: 'GENERAL_TAXPAYER'
    }
];

export const invoiceAmountDataSource = [
    {
        label: '零申报',
        value: 'ZERO'
    },
    {
        label: '非零申报',
        value: 'SMALL'
    }
];

export const yearDatasource = [
    {
        text: '1年',
        value: 1
    }
];